import Configs from '@/configs'
import { parsedContent } from '@/lib/utils'

import golfTips from '~/public/images/golf-club-storage/tips.png'
import golfWall from '~/public/images/golf-club-storage/wall.png'
import golfRacks from '~/public/images/golf-club-storage/racks.png'

import luggageExperience from '~/public/images/luggage-storage/experience.png'
import luggageGuarantee from '~/public/images/luggage-storage/guarantee.png'
import luggageLocation from '~/public/images/luggage-storage/location.png'
import luggageHours from '~/public/images/luggage-storage/hours.png'
import luggageSupport from '~/public/images/luggage-storage/support.png'
import luggageHassle from '~/public/images/luggage-storage/hassle-free.png'

import skiWall from '~/public/images/ski-storage/wall.png'
import skiStorage from '~/public/images/ski-storage/storage.png'
import skiPortable from '~/public/images/ski-storage/portable.png'

import snowWall from '~/public/images/snowboard-storage/wall.png'
import snowOverhead from '~/public/images/snowboard-storage/overhead.png'
import snowTravel from '~/public/images/snowboard-storage/travel.png'
import snowClean from '~/public/images/snowboard-storage/clean.png'
import snowDamage from '~/public/images/snowboard-storage/inspect.png'
import snowProperty from '~/public/images/snowboard-storage/property.png'

const imageClass = {
  wrClassName: 'pt-6 md-mn:pt-0 flex items-end md-mn:items-center lg-mn:items-end md-mn:pl-2 lg-mn:pl-0 '
}

const appName = Configs.APP_NAME

export const INNOVATIVE = Object.freeze({
  golfClub: {
    sectionClassName: 'bg-white-ice',
    header: {
      title: parsedContent(`Innovative Golf Club Storage Solutions`),
      subtitle: parsedContent(
        `
          <p>There are several innovative golf equipment storage solutions available to help golfers organize and protect their clubs effectively.</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: golfTips,
            alt: 'Golf bag organization tips',
            wrClassName: imageClass.wrClassName + 'w-[151px] h-[202px]'
          },
          heading: parsedContent('Golf bag organization tips', 'max-w-full'),
          subheading: parsedContent(
            `Organizing the contents of your golf bag in an ideal golf bag storage system can help prevent clubs from banging against each other during transport. Utilizing dividers and compartments within the bag can keep clubs separated and minimize the risk of damage.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: golfWall,
            alt: 'Wall-mounted storage options',
            wrClassName: imageClass.wrClassName + 'w-[128px] h-[206px]'
          },
          heading: parsedContent('Wall-mounted storage options', 'max-w-full'),
          subheading: parsedContent(
            `Wall-mounted storage racks or systems can be a space-saving and efficient way to store golf clubs. These systems can keep clubs off the ground, organized, and easily accessible for quick retrieval before a round of golf.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: golfRacks,
            alt: 'Customized storage racks',
            wrClassName: imageClass.wrClassName + 'w-[111px] h-[196px]'
          },
          heading: parsedContent('Customized storage racks', 'max-w-full'),
          subheading: parsedContent(
            `For those with a larger collection of clubs, customized storage racks can be designed to fit specific spaces and accommodate the individual needs of the golfer. These racks can be tailored to hold various types of clubs and accessories in an organized and secure manner.`
          )
        }
      ]
    }
  },
  skiStorage: {
    sectionClassName: 'bg-white-ice',
    header: {
      title: parsedContent(`Innovative Ski Storage Systems`),
      subtitle: parsedContent(
        `
          <p>Innovative storage solutions can help you keep your ski gear organized and in top condition. Here are some options to consider:</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: skiWall,
            alt: 'Wall-Mounted Racks',
            wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
          },
          heading: parsedContent('Wall-Mounted Racks', 'max-w-full'),
          subheading: parsedContent(
            `Wall-mounted ski racks are a space-saving and efficient way to store skis, poles, and boots. These ski storage racks keep your gear off the ground and out of the way, while also allowing for proper ventilation to prevent moisture buildup.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: skiStorage,
            alt: 'Freestanding Storage Systems',
            wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
          },
          heading: parsedContent('Freestanding Storage Systems', 'max-w-full'),
          subheading: parsedContent(
            `<strong>${appName}</strong> systems offer flexibility and mobility, allowing you to reconfigure your storage setup as needed. These systems often include shelves, hooks, and compartments for organizing all your ski gear in one place.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: skiPortable,
            alt: 'Portable Ski Bags',
            wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
          },
          heading: parsedContent('Portable Ski Bags', 'max-w-full'),
          subheading: parsedContent(
            `Portable ski bags are ideal for transporting and storing your skis and poles. Look for a bag with padded compartments and durable construction to protect your gear during travel and storage.`
          )
        }
      ]
    }
  },
  luggageStorage: {
    sectionClassName: 'bg-white-ice',
    header: {
      title: parsedContent(`Why choose ${appName} for luggage storage in NYC?`),
      subtitle: parsedContent(
        `
          <p>When it comes to storing your luggage in New York City, <strong>${appName}</strong> offers unmatched convenience and peace of mind. Here's why you should choose our service:</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-2 lg-mn:grid-cols-3 gap-7',
      data: [
        {
          image: {
            src: luggageExperience,
            alt: 'Experience',
            wrClassName: imageClass.wrClassName + 'w-[197px] h-[177px]'
          },
          heading: parsedContent('Experience', 'max-w-full'),
          subheading: parsedContent(
            `With our years of experience, we know how to run a luggage storage service in a busy city like NYC.`
          )
        },
        {
          image: {
            src: luggageGuarantee,
            alt: 'Guarantee',
            wrClassName: imageClass.wrClassName + 'w-[197px] h-[177px]'
          },
          heading: parsedContent('Guarantee', 'max-w-full'),
          subheading: parsedContent(
            `<strong>${appName}</strong> provides a guarantee for every stored item, offering coverage of up to $250.`
          )
        },
        {
          image: {
            src: luggageLocation,
            alt: 'Convenient Locations',
            wrClassName: imageClass.wrClassName + 'w-[199px] h-[177px]'
          },
          heading: parsedContent('Convenient Locations', 'max-w-full'),
          subheading: parsedContent(
            `Our storage units are spread out in the city so you don't have to travel far to get your things.`
          )
        },
        {
          image: {
            src: luggageHours,
            alt: 'Flexible Hours',
            wrClassName: imageClass.wrClassName + 'w-[199px] h-[185px]'
          },
          heading: parsedContent('Flexible Hours', 'max-w-full'),
          subheading: parsedContent(
            `Store your luggage anytime! <strong>${appName}</strong> ensures you can always find an available storage spot, even during odd hours.`
          )
        },
        {
          image: {
            src: luggageSupport,
            alt: 'Personalized Support',
            wrClassName: imageClass.wrClassName + 'w-[197px] h-[177px]'
          },
          heading: parsedContent('Personalized Support', 'max-w-full'),
          subheading: parsedContent(
            `You'll speak with a real person, not a bot, who will advocate on your behalf until any issue is resolved to your satisfaction.`
          )
        },
        {
          image: {
            src: luggageHassle,
            alt: 'Hassle-free Luggage Shipping',
            wrClassName: imageClass.wrClassName + 'w-[197px] h-[177px]'
          },
          heading: parsedContent('Hassle-free Luggage Shipping', 'max-w-full'),
          subheading: parsedContent(
            `With <strong>${appName}</strong>, storing your luggage in NYC is hassle-free, secure, and backed by exceptional service.`
          )
        }
      ]
    }
  },
  snowboardStorage: {
    top: {
      sectionClassName: 'bg-white-ice',
      header: {
        title: parsedContent(`Snowboard Storage Options`),
        subtitle: parsedContent(
          `
          <p>There are various snowboard storage options available, each with its own set of advantages and considerations. Here are some popular options to consider:</p>
        `,
          'max-w-[1050px]'
        )
      },
      content: {
        descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7',
        data: [
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowWall,
              alt: 'Wall-Mounted Racks',
              wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
            },
            heading: parsedContent('Wall-Mounted Racks', 'max-w-full'),
            subheading: parsedContent(
              `Wall mounted ski and snowboard racks are a great space-saving option, allowing you to store your snowboards vertically against a wall. The snowboard wall mount rack is an ideal solution for those looking to free up floor space while keeping their snowboards easily accessible.`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowOverhead,
              alt: 'Overhead Storage Systems',
              wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
            },
            heading: parsedContent('Overhead Storage Systems', 'max-w-full'),
            subheading: parsedContent(
              `Overhead storage systems are an excellent choice for those with limited floor space. These systems allow you to store your snowboards and gear overhead, keeping them out of the way while still easily accessible when needed`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowTravel,
              alt: 'Travel Bags And Cases',
              wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
            },
            heading: parsedContent('Travel Bags And Cases', 'max-w-full'),
            subheading: parsedContent(
              `Travel bags and cases are essential for people who often go on adventure trips or need to transport their snowboards. These bags and cases protect the snowboard during transit and storage, keeping it safe and secure.`
            )
          }
        ]
      }
    },
    bottom: {
      sectionClassName: 'bg-white-ice',
      header: {
        title: parsedContent(`Maintaining and Caring for Your Snowboard Storage Solution`),
        subtitle: parsedContent(
          `
          Once you've found the perfect snowboard boot storage solution, it's important to maintain and care for it properly to ensure its longevity and effectiveness:
        `,
          'max-w-[1050px]'
        )
      },
      content: {
        descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7',
        data: [
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowClean,
              alt: 'Regular Cleaning And Maintenance',
              wrClassName: imageClass.wrClassName + 'w-[209px] h-[141px]'
            },
            heading: parsedContent('Regular Cleaning And Maintenance', 'max-w-full'),
            subheading: parsedContent(
              `Regularly clean and maintain your snowboard gear storage system to keep it in top condition. This may involve wiping down racks, inspecting for any signs of wear, and ensuring that the system remains secure and stable.`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowDamage,
              alt: 'Inspecting For Damage Or Wear',
              wrClassName: imageClass.wrClassName + 'w-[209px] h-[141px]'
            },
            heading: parsedContent('Inspecting For Damage Or Wear', 'max-w-full'),
            subheading: parsedContent(
              `Inspect your indoor snowboard storage system for any signs of damage or wear. This includes checking for loose screws, worn-out padding, or any other issues that may compromise the safety and security of your snowboard.`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowProperty,
              alt: 'Properly Storing Accessories And Gear',
              wrClassName: imageClass.wrClassName + 'w-[209px] h-[141px]'
            },
            heading: parsedContent('Properly Storing Accessories And Gear', 'max-w-full'),
            subheading: parsedContent(
              `In addition to storing your snowboard, ensure that your accessories and gear are also properly stored. This may involve using hooks or compartments to keep helmets, boots, and other gear organized and easily accessible.`
            )
          }
        ]
      }
    }
  }
})
